import { handleError } from "../../../util/errors";
import apiBase from "../../api";
import {
  NOTIFICATION_RECIPIENTS,
  NOTIFICATION_RECIPIENT,
  NOTIFICATION_RECIPIENT_TOGGLE,
  NOTIFICATION_SUBSCRIPTIONS,
  NOTIFICATION_SUBSCRIPTION,
  NOTIFICATION_SUBSCRIPTION_TOGGLE,
  FETCH_BUSINESS_UNITS_LIST,
} from "../../urls";

class NotificationService {
  // Notification Recipients (global, for company change notifications)
  fetchRecipients = async () => {
    try {
      const response = await apiBase.get(NOTIFICATION_RECIPIENTS);
      const { data } = response.data;
      return { data };
    } catch (err) {
      throw handleError(err, "Error fetching notification recipients");
    }
  };

  createRecipient = async (recipientData) => {
    try {
      const response = await apiBase.post(NOTIFICATION_RECIPIENTS, recipientData);
      return response.data;
    } catch (err) {
      throw handleError(err, "Error creating notification recipient");
    }
  };

  updateRecipient = async (id, recipientData) => {
    try {
      const response = await apiBase.put(NOTIFICATION_RECIPIENT(id), recipientData);
      return response.data;
    } catch (err) {
      throw handleError(err, "Error updating notification recipient");
    }
  };

  deleteRecipient = async (id) => {
    try {
      const response = await apiBase.delete(NOTIFICATION_RECIPIENT(id));
      return response.data;
    } catch (err) {
      throw handleError(err, "Error deleting notification recipient");
    }
  };

  toggleRecipient = async (id) => {
    try {
      const response = await apiBase.patch(NOTIFICATION_RECIPIENT_TOGGLE(id));
      return response.data;
    } catch (err) {
      throw handleError(err, "Error toggling notification recipient");
    }
  };

  // Notification Subscriptions (per-user, per-business-unit for device status)
  fetchSubscriptions = async () => {
    try {
      const response = await apiBase.get(NOTIFICATION_SUBSCRIPTIONS);
      const { data } = response.data;
      return { data };
    } catch (err) {
      throw handleError(err, "Error fetching notification subscriptions");
    }
  };

  createSubscription = async (subscriptionData) => {
    try {
      const response = await apiBase.post(NOTIFICATION_SUBSCRIPTIONS, subscriptionData);
      return response.data;
    } catch (err) {
      throw handleError(err, "Error creating notification subscription");
    }
  };

  updateSubscription = async (id, subscriptionData) => {
    try {
      const response = await apiBase.put(NOTIFICATION_SUBSCRIPTION(id), subscriptionData);
      return response.data;
    } catch (err) {
      throw handleError(err, "Error updating notification subscription");
    }
  };

  deleteSubscription = async (id) => {
    try {
      const response = await apiBase.delete(NOTIFICATION_SUBSCRIPTION(id));
      return response.data;
    } catch (err) {
      throw handleError(err, "Error deleting notification subscription");
    }
  };

  toggleSubscription = async (id) => {
    try {
      const response = await apiBase.patch(NOTIFICATION_SUBSCRIPTION_TOGGLE(id));
      return response.data;
    } catch (err) {
      throw handleError(err, "Error toggling notification subscription");
    }
  };

  // Business Units list for dropdown
  fetchBusinessUnits = async () => {
    try {
      const response = await apiBase.get(FETCH_BUSINESS_UNITS_LIST);
      const { data } = response.data;
      return { data };
    } catch (err) {
      throw handleError(err, "Error fetching business units");
    }
  };
}

export default new NotificationService();
